export const TYPES_OF_LISTING = {
  HUNTING: "HUNTING",
  AGRICULTURAL: "AGRICULTURAL,TILLABLE_NON_IRRIGATED,TILLABLE_IRRIGATED",
  SALE_NON_AUCTION: "SALE_NON_AUCTION",
  SALE_AUCTION: "SALE_AUCTION",
};
